import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RestTimeClaimHandling, RestTimeStatus } from '@vierkant-software/types__api';
import { GcInfoComponent, Severity } from '../v-info/v-info.component';
import { GcLayoutModule } from '../v-layout/layout.module';
import { VDateModule } from '../v-date/v-date.module';
import { VCurrencyDirective } from '../currency.directive';
import { VTranslateDirective } from '../vtranslate.directive';
import { VTranslatePipe } from 'src/app/pipes/vtranslate.pipe';
import { RestTimeSummary } from 'src/util/restTime';

/**
 * What a rest time costs and changes: agreed fees, what was actually charged, credits and the
 * contract extensions. Shown in the detail modal and in the cancellation step, which must not
 * disagree with each other.
 *
 * @name Rest time effects
 * @tags Rest time, Summary, Display
 * @example
 * ```
 * %v-rest-time-effects{[summary]: "detail", noticeKey: "REST_TIME.EFFECTS.CANCEL_NOTICE"}
 * ```
 */
@Component({
    selector:    'v-rest-time-effects',
    templateUrl: './v-rest-time-effects.component.haml',
    styleUrls:   ['./v-rest-time-effects.component.sass'],
    standalone:  true,
    imports:     [
        CommonModule, GcLayoutModule, GcInfoComponent, VDateModule,
        VCurrencyDirective, VTranslateDirective, VTranslatePipe,
    ],
})
export class VRestTimeEffectsComponent {
    @Input({ required: true }) public summary: RestTimeSummary;
    /** extra sentence below the block, e.g. that a cancellation takes these effects back */
    @Input() public noticeKey: string | undefined;
    @Input() public severity: Severity = 'default';

    public claimHandling = RestTimeClaimHandling;

    public get hasCredits(): boolean {
        return !!this.summary?.effectRows?.some(row => row.credited !== 0);
    }

    /** `isApplied` is false both before the rest time begins and after it was cancelled */
    public get extensionHeadingKey(): string {
        if (this.summary?.isApplied) return 'REST_TIME.EFFECTS.EXTENSION_HEADING';
        if (this.summary?.status === RestTimeStatus.canceled) return 'REST_TIME.EFFECTS.EXTENSION_HEADING_REVERSED';
        return 'REST_TIME.EFFECTS.EXTENSION_HEADING_EXPECTED';
    }
}
